export interface IMeetingInfo {
  id: string;
  stage: string;
  started?: string;
  finished?: string;
}
